<template>
    <div class="map-container">
        <!-- <h3>{{$t('accommodation.location')}}</h3> -->

        <GmapMap
            v-if="posicion"
            :center="posicion"
            ref="mapRef"
            :zoom="16"
            map-type-id="roadmap"
            style="width: 100%; height: 520px"
            :options="options"
        >
            <GmapMarker :position="posicion" />
        </GmapMap>

        <!-- Sin coordenadas válidas (hay alojamientos cargados con -99.9999 / -999.9999)
             y sin poder ubicar la dirección: mejor un aviso que un mapa vacío. -->
        <div v-else-if="sinUbicacion" class="map-empty" role="status">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21Z" /><circle cx="12" cy="9.5" r="2.5" /></svg>
            <p>{{ $t('ficha_nueva.map_unavailable') }}</p>
            <p v-if="direccion" class="map-empty-d">{{ direccion }}</p>
        </div>
    </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

/** Latitud/longitud reales (descarta vacías, 0,0 y fuera de rango). */
function coordenadaValida(lat, lng) {
    if (lat === null || lat === undefined || lat === '' || lng === null || lng === undefined || lng === '') return false;
    const la = Number(lat);
    const ln = Number(lng);
    if (!isFinite(la) || !isFinite(ln)) return false;
    if (Math.abs(la) > 90 || Math.abs(ln) > 180) return false;
    return !(la === 0 && ln === 0);
}

export default {
    name: "DetalleAlojamientoLocation",
    props: ["data"],
    data() {
        return {
            options: {
                backgroundColor: "#003D29",
                disableDefaultUI: false,
                scrollwheel: true,
                minZoom: 2,
                // Arriba a la izquierda están los botones Fotos | Mapa de la ficha:
                // el selector Mapa/Satélite se acomoda en mounted() para no quedar debajo.
            },
            geocodificada: null,
            sinUbicacion: false,
            url: process.env.VUE_APP_S3_URL
        };
    },
    computed: {
        google: gmapApi,

        coordenadasValidas() {
            return !!this.data && coordenadaValida(this.data.latitud, this.data.longitud);
        },

        posicion() {
            if (this.coordenadasValidas) return { lat: Number(this.data.latitud), lng: Number(this.data.longitud) };
            return this.geocodificada;
        },

        direccion() {
            const d = this.data || {};
            return [d.direccion, d.ciudad, d.pais]
                .map(v => (v == null ? '' : String(v).trim()))
                .filter(v => v && v !== 'null')
                .join(', ');
        },
    },
    async mounted() {
        await this.$gmapApiPromiseLazy();
        const g = this.google;
        if (!g) return;

        this.options = {
            ...this.options,
            mapTypeControlOptions: { position: g.maps.ControlPosition.BOTTOM_LEFT },
        };

        if (!this.coordenadasValidas) this.ubicarPorDireccion(g);
    },
    methods: {
        /** Sin coordenadas: se intenta ubicar la dirección; si no se puede, se muestra el aviso. */
        ubicarPorDireccion(g) {
            if (!this.direccion) { this.sinUbicacion = true; return; }
            try {
                new g.maps.Geocoder().geocode({ address: this.direccion }, (res, status) => {
                    if (status === 'OK' && res && res[0]) {
                        const l = res[0].geometry.location;
                        this.geocodificada = { lat: l.lat(), lng: l.lng() };
                    } else {
                        this.sinUbicacion = true;
                    }
                });
            } catch (e) {
                this.sinUbicacion = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.map-container {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    width: 100%;

    h3 {
        padding: 20px 0 15px;
        margin: 0;
        font-size: 1.4em;
        color: #003D29;
    }
}

.map-empty {
    height: 100%;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 24px;
    text-align: center;
    color: #4a4a4a;

    svg {
        width: 34px;
        height: 34px;
        margin-bottom: 4px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.6;
    }

    p { margin: 0; font-weight: 600; }
    .map-empty-d { font-weight: 400; font-size: 14px; color: #6b6b6b; }
}
</style>
